import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {CommissionSettlement} from '../../../../shared/interface/commission-settlement';
import {takeUntil} from 'rxjs/operators';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {CommissionSettlementService} from '../../../../shared/services/commission-settlement.service';
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {COMMISSION_SETTLEMENT_STATUS_NEW, COMMISSION_SETTLEMENT_STATUS_TO_GENERATE} from "../../../../shared/services/dict.service";
import {CommissionContractSettlement} from "../../../../shared/interface/commission-contract-settlement";
import {LogService} from "../../../../shared/services/log.service";
import {Log} from "../../../../shared/interface/log";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {RiskConfiguration} from "../../../../shared/interface/risk-configuration";
import {Invoice} from "../../../../shared/interface/invoice";

@Component({
  selector: 'app-settlement-details-view',
  templateUrl: './settlement-details-view.component.html',
  styleUrls: ['./settlement-details-view.component.scss']
})
export class SettlementDetailsViewComponent implements OnInit, OnDestroy{

  @Input() commissionSettlement: Observable<CommissionSettlement>;

  readonly COMMISSION_SETTLEMENT_STATUS_NEW = COMMISSION_SETTLEMENT_STATUS_NEW;
  readonly COMMISSION_SETTLEMENT_STATUS_TO_GENERATE = COMMISSION_SETTLEMENT_STATUS_TO_GENERATE;

  logs: any[] = [];
  commissionSettlementObject: CommissionSettlement;

  userPermissions: ReplaySubject<UserPermissions>;
  processingRequest = false;
  displayedColumns: string[] = ['number', 'date', 'net', 'status'];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private snack: MatSnackBar,
    private commissionSettlementService: CommissionSettlementService,
    private logService: LogService,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.loadData();
  }
  loadCommissionSettlement(): void {
    this.commissionSettlementService.get(this.commissionSettlementObject.uuid).subscribe((commissionSettlement: CommissionSettlement) => {
      this.commissionSettlementObject = commissionSettlement;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Rozliczenie zostało usunięte', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/rozliczenia']);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  downloadReport(): void {
    this.commissionSettlementService.downloadSettlementReport(
      this.commissionSettlementObject.uuid
    );
  }

  downloadDetailedReport(): void {
    this.commissionSettlementService.downloadSettlementDetailedReport(
      this.commissionSettlementObject.uuid
    );
  }
  sendReport(commissionContractSettlement: CommissionContractSettlement): void {
    this.commissionSettlementService.sendRaport(commissionContractSettlement.uuid)
      .subscribe((response) => {
        this.loadData();
        this.snack.open('Rozliczenie zostało wysłane',  '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy wysyłąniu rozliczenia wystąpił błąd', error.status.toString(), {duration: 2000});
        if (error.status === 400) {
          this.snack.open(error.error.error.text, '400', {duration: 4000});
        }
      });
  }
  sendPassword(commissionSettlement: CommissionSettlement): void {
    this.commissionSettlementService.sendPassword(commissionSettlement.uuid)
      .subscribe((response) => {
        this.loadData();
        this.snack.open('Hasło zostało wysłane',  '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy wysyłąniu hasła wystąpił błąd', error.status.toString(), {duration: 2000});
        if (error.status === 400) {
          this.snack.open(error.error.error.text, '400', {duration: 4000});
        }
      });

  }

  loadData(): void{
    this.commissionSettlement
      .pipe(takeUntil(this.destroyed$))
      .subscribe((commissionSettlement: CommissionSettlement) => {
        this.commissionSettlementObject = commissionSettlement;
        this.commissionSettlementObject.contractSettlements.forEach((cs) => {
          cs.invoices.sort((a, b) =>
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
        });
        const log: Log[] = [];
        commissionSettlement.contractSettlements.forEach((contractSettlement) => {
          this.logService.getComissionContractLogDate(contractSettlement.uuid, 0, 100)
            .pipe(
              takeUntil(this.destroyed$)
            ).subscribe((result) => {
            log.push(result);
          });
        });
          this.logService.getComissionSettlementLogDate(this.commissionSettlementObject.uuid, 0, 100)
            .pipe(
              takeUntil(this.destroyed$)
            ).subscribe((result) => {
            log.push(result);
          });
        this.logs = log;
      });
  }
  generateCommissionSettlements(): void {
    this.processingRequest = true;
    this.commissionSettlementService.generateCommissionSettlements(this.commissionSettlementObject.uuid)
      .subscribe((response) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {
            jobId: response.uuid,
            showProgress: false,
            title: `Generowanie rozliczenie dla: ${this.commissionSettlementObject?.partner?.shortName ? this.commissionSettlementObject?.partner?.shortName : this.commissionSettlementObject?.ofwca?.fullName}`
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          this.loadCommissionSettlement();
          this.snack.open(`Rozliczenie dla: ${this.commissionSettlementObject?.partner?.shortName ? this.commissionSettlementObject?.partner?.shortName : this.commissionSettlementObject?.ofwca?.fullName} zostały zaktualizowane`, '', {duration: 2000});
        });
    }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
      this.snack.open('Przy aktualizowaniu rozliczenia wystąpił błąd', error.status.toString(), {duration: 2000});
    });
  }
  onImgError($event: ErrorEvent): void {
    // @ts-ignore
    $event.target.src = '/assets/avatar.png';
  }
}
